jQuery(document).ready(function ($) {

	let height, width, marginBottom;

	let screenHeight = $(window).height();

	let scrollBlockPosition = $('.services-scrolling').offset().top;
	const isIotConsultingPage = $('.services-scrolling').hasClass('fixed-height');

	function calculateSizes(k) {
		height = window.screen.height * k;
		width = height * 1.8;
	}

	(window.screen.height <= 900) ? calculateSizes(0.55) : calculateSizes(0.4);

	function setSize() {
		$(".panel").height(height);
		$('.panel').css({width: + width +'px'});
		if (!isIotConsultingPage) {
			$(".panel").height(height);
		} else {
			const heights = $('.panel').map(function () {
				return $(this).find('.scrolling-list__item').height();
			}).get();

			const maxHeight = Math.max.apply(null, heights);

			$('.panel').each(function () {
				$(this).css({ minHeight:  maxHeight});
			});
		}

		let finalHeight = $(".panel").innerHeight();
		$(".horiz-slider-container").height(finalHeight + 50);
	}

	if (window.screen.width > 1024) {

		setSize();

		let horizWidth = $('.horizontal-scroll-wrapper').width() * 2;
		$('.overlay-section').css({height: + horizWidth +'px'});

		for(let i = 1; i < $(".scrolling-list__item").length; i++) {
			$(".scrolling-list__item")[i].classList.remove('element-show');
		}


		let allElemHorScrl = document.querySelectorAll('.scrolling-list__item');
		let horizOverflowBlock = document.querySelector('.horizontal-scroll-wrapper');
		let mainInformationSlider = document.querySelector('.main-info_slider');
		let navigationNumberSlides = document.querySelector('.navigation-block');

		totalBlock.innerText = `/${allElemHorScrl.length}`;
		function onEntry(entry) {
			entry.forEach(change => {

				if (change.isIntersecting) {
					let index = 0;
					for (elem of allElemHorScrl) {
						elem.classList.remove('element-show');
					}
					change.target.classList.add('element-show');
					for (elem of allElemHorScrl) {
						if(elem.classList.contains('element-show')) {
							currentBlock.innerText = `0${index+1}`;
						}
						index++;
					}
				}
			});
		}

		let options;

		if (window.screen.height <= 960) {
			options = {

				rootMargin: '5% -33% 5% -32%',
				threshold: 0.4
			};
		} else {
			options = {
				root: document.querySelector('.horiz-slider-container'),
				rootMargin: '5% -33% 5% -32%',
				threshold: 0.4
			};
		}


		let observer = new IntersectionObserver(onEntry, options);

		for (let elm of allElemHorScrl) {
			observer.observe(elm);
		}


		let checkSectionInView;
		let someParam = false;

		let scrollingSection = document.querySelector('.services-scrolling');

		let numberOfPanels = allElemHorScrl.length;
		let isDescription = $('.main-info_slider').outerHeight();

		document.addEventListener('wheel', (event)=>{
			let scrollX = window.pageYOffset;
			let sectionTouchHeader = fixedScrollSection();
			let sectionTouchBottomOfThePage = fixedScrollSectionBottom();
			let currentIndex = $('#currentBlock').text();
			if ( event.deltaY > 0) {

				if ( sectionTouchHeader && isDescription ) {

					mainInformationSlider.classList.add( 'hide' );

					navigationNumberSlides.classList.add( 'active' );
					horizOverflowBlock.classList.add( 'scroll' );

					someParam = true;
					scrollIndicator();

				}
				if ( sectionTouchHeader && !isDescription ) {

					navigationNumberSlides.classList.add( 'active' );
					horizOverflowBlock.classList.add( 'scroll' );

					someParam = false;
					scrollIndicator();

				}
				if (sectionTouchHeader && (currentIndex == numberOfPanels)) {
					someParam = true;
				}

			} else {

				if ( (currentIndex == 1) && checkSectionInView && someParam ){
					setTimeout(()=>{
						if(mainInformationSlider.classList.contains( 'hide' )) {
							mainInformationSlider.classList.remove( 'hide' );
						}
					}, 200);

				}

				if (sectionTouchBottomOfThePage ) {
					scrollIndicator();
					someParam = true;
				}
			}
		})


		function onEntry2(entry2) {
			entry2.forEach(change2 => {
				if (change2.isIntersecting) {
					checkSectionInView = true;
				} else {
					checkSectionInView = false;
				}
			});
		}

		let options2 = {
			root: null,
			rootMargin: '-80% 0px 0px 0px',
			threshold: 0
		};

		let observer2 = new IntersectionObserver(onEntry2, options2);

		observer2.observe(scrollingSection);


		function scrollIndicator() {
			const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
			let scrolled = ( (winScroll - scrollBlockPosition) / ( $('.overlay-section').outerHeight() ) ) *100 ;

			if (scrolled <= 85) {
				horizOverflowBlock.style.transform = `translateX(-${scrolled}%)`;
			}
		}

		function scrollIndicatorToTop() {
			let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
			let scrolled = ( (winScroll -  $('.overlay-section').outerHeight()) / ( $('.overlay-section').outerHeight()  ) ) *100 ;

			horizOverflowBlock.style.transform = `translateX(-${scrolled}%)`;
		}
	}


	function fixedScrollSection() {
		let headerPosition = $(".header").offset().top + $(".header").outerHeight();
		let sectionPosition = $(".overlay-section").offset().top;
		if( sectionPosition <= headerPosition ){
			return true;
		} else {
			return false;
		}
	}

	function fixedScrollSectionBottom() {
		let pagePosition = $(".header").offset().top + $(".header").outerHeight() + $(".services-scrolling").outerHeight();
		let sectionBottomPosition = $(".overlay-section").offset().top + $(".overlay-section").outerHeight();

		if( sectionBottomPosition >= pagePosition ){
			return true;
		}
	}

});